import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useNotificationsApi } from "@circle-react/hooks/notifications/useNotificationsApi";
import { useNotificationWebSocket } from "@circle-react/hooks/notifications/useNotificationWebSocket";
import { useEffect } from "react";

export const useNotificationDropdown = () => {
  const { currentCommunity, currentCommunityMember } = usePunditUserContext();
  const {
    newNotificationCount,
    fetchNewNotificationsCount,
    resetNewNotificationsCount,
    onNotificationEventReceive,
  } = useNotificationsApi();

  useNotificationWebSocket(
    currentCommunityMember?.id as number,
    onNotificationEventReceive,
  );

  useEffect(() => {
    if (!currentCommunityMember) return;
    void fetchNewNotificationsCount(currentCommunity?.id);
  }, [currentCommunity?.id, currentCommunityMember]);

  return {
    newNotificationCount,
    resetNewNotificationsCount,
  };
};
